module.exports = __webpack_public_path__ + "static/media/alert-icon.89e6e428.svg";